import React from "react";
import Circle from "components/Pattern/Circle";

const ProfileLayout = ({ children, profile }) => {
  return (
    <div className="bg-wce-neutral-2 py-18 px-8 w-full mx-auto">
      {!profile?.name ? (
        ""
      ) : (
        <div className="max-w-3xl flex flex-col mx-auto">
          <div className="mb-14 font-semibold text-xl sm:text-5xl text-center">
            <span className="text-wce-navy">Hello,</span>
            <span className="text-wce-pink-dark">{` ${profile?.name}`}</span>
            <span className="text-wce-navy">!</span>
          </div>
          <div className="z-10">{children}</div>
        </div>
      )}
      <Circle variant="one" />
    </div>
  );
};

export default ProfileLayout;
